// F1 Awards Page
import React from 'react';
import { useF1Championship } from '../../hooks/useF1Championship';
import F1PageTemplate from '../../components/f1/F1PageTemplate';
import { awardsConfig } from '../../components/f1/AwardsComponent';
import AwardsComponent from '../../components/f1/AwardsComponent';

const F1AwardsPage = () => {
  const { data } = useF1Championship();

  const stats = awardsConfig.stats.map(stat => ({
    ...stat,
    value: typeof stat.value === 'function' ? stat.value(data) : stat.value
  }));

  return (
    <F1PageTemplate
      title={awardsConfig.title}
      subtitle={awardsConfig.subtitle}
      summary={awardsConfig.summary}
      stats={stats}
    >
      <AwardsComponent data={data} />
    </F1PageTemplate>
  );
};

export default F1AwardsPage;
